"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketingOptIn = void 0;
var marketing_opt_in_1 = require("./marketing-opt-in");
Object.defineProperty(exports, "MarketingOptIn", { enumerable: true, get: function () { return marketing_opt_in_1.MarketingOptIn; } });
